import FormButton from '../../generic/buttons/main/index2';
import { isProductNotExpired } from '../../../lib/utils/helpers';
import { t } from 'i18next';
import { BASE_SILAVETRA_URL } from '../../../lib/api/globalState';
import React, {useEffect, useState} from 'react';
import { observer } from 'mobx-react-lite';
import { useInjection } from 'brandi-react';
import { AdventureScheduleModelStoreToken } from './model';
import ArrivalSelector from "./ArrivalSelector";
import PresetArrival from "./PresetArrival";
import PriceBlock from "../Price";
import AlertDismissibleExample from '../../common/GlobalSaleAlert';
import {handleAddToCart, sendAnalyticsEvents} from "../../../lib/utils/analytics";
import TimoutRedirect from "../../common/TimoutRedirect";

const ScheduleUI = (props) => {
  const {
    isArrivalPreset,
    arrivals,
    noSeatsAvailable,
    isButtonDisabled,
    pickedArrival,
    updateData,
    onSubmit,
    peopleAmount,
    isShowOnMainButton,
    arrivalUrlParam,
    isClosed,
  } = props;

  const adventureScheduleModel = useInjection(AdventureScheduleModelStoreToken);
  const [productData, setProductData] = useState(null);
  const [categoryParams, setCategoryParams] = useState(null);

    useEffect(() => {
        const isCamp = pickedArrival?.adventure_id?.is_camp;
        const isCharter = pickedArrival?.adventure_id?.is_charter;
        const travelType = pickedArrival?.adventure_id?.type;

        const getProductType = () => {
            if (isCamp) return `camp_${travelType}`;
            if (isCharter) return 'charter';
            return `travel_${travelType}`;
        };

        setCategoryParams({
            product_type: getProductType(),
            arrival: {
                city: pickedArrival?.city,
                country: pickedArrival?.country,
                start_date: pickedArrival?.start_date,
                end_date: pickedArrival?.end_date,
            },
        })
        setProductData({
            id: pickedArrival?.web_url_products || pickedArrival?.adventure_id?.web_url_products,
            name: pickedArrival?.name,
            price: pickedArrival?.price_value,
            quantity: peopleAmount,
        });
    }, [peopleAmount, pickedArrival])

  const isExpired = !isProductNotExpired(pickedArrival?.start_date);
  const shouldShowButton = !noSeatsAvailable && (isArrivalPreset || !!arrivals?.length);
  const redirectUrl = BASE_SILAVETRA_URL + "/travel";

  const getButtonText = () => {
      if (isExpired) return t('common.bookingClosed');
      if (isShowOnMainButton || isClosed) return t('common.toMain');
      return t('common.next');
  };

  const getButtonAction = (event) => {
      event.preventDefault();

      if (isClosed || isShowOnMainButton) {
          window.location.href = redirectUrl;
          return;
      }

      sendAnalyticsEvents('date_main', 1);
      handleAddToCart(productData, categoryParams);
      adventureScheduleModel.submitWithValidation(onSubmit, peopleAmount);
  };

  const isDisabled = () => {
      if (isClosed) return false;
      if (isShowOnMainButton) return false;
      return isButtonDisabled || isExpired;
  };

  return (
    <div className={"schedule schedule__travel"}>
      <>
        {
          !isArrivalPreset && arrivals
            ? <ArrivalSelector updateData={updateData} arrivals={arrivals} />
            : <PresetArrival arrival={pickedArrival} />
        }
        <AlertDismissibleExample />
        {isShowOnMainButton &&
            <p className={`${isArrivalPreset && "d-none"} m-3 d-lg-block`}>{t('common.placesEnded')}</p>
        }
        {isClosed &&
            <TimoutRedirect text={`${t('common.bookingClosed')}. ${t('common.redirect')}`} seconds={60} href={redirectUrl} className="arrivalFromUrl"/>
        }
        {shouldShowButton && (
            <FormButton
                data-testid='next-submit'
                disabled={isDisabled()}
                value={getButtonText()}
                className={"d-none d-lg-block stickyButton"}
                onClick={getButtonAction}
            />
        )}

        {(isArrivalPreset || arrivalUrlParam) && pickedArrival && (
          <PriceBlock isShowOnMainButton={isShowOnMainButton}
                      selectedCurrency={pickedArrival?.price_currency} noSeatsAvailable={noSeatsAvailable}
                      isButtonDisabled={isDisabled()}
                      buttonValue={getButtonText()}
                      onSubmit={(event) => {
                          sendAnalyticsEvents('date_main', 1);
                          handleAddToCart(productData, categoryParams);
                          event.preventDefault()
                          if (onSubmit) {
                              adventureScheduleModel.submitWithValidation(onSubmit, peopleAmount)
                          }
                      }}
                      isClosed={isClosed}
          />
        )}
        {adventureScheduleModel.isArrivalOverbooked &&
        <p className="m-3">{t('errors.someoneAlready')}</p>
        }
      </>
    </div>
  )
}

export default observer(ScheduleUI);